import { Component, ChangeDetectionStrategy } from "@angular/core";
import { TranslatePipe } from "@ngx-translate/core";

@Component({
    selector: "rask-permission-denied",
    templateUrl: "./permission-denied.component.html",
    styleUrls: ["./permission-denied.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [TranslatePipe]
})
export class PermissionDeniedComponent {

}
